export default __webpack_public_path__ + "static/media/winner_13.9cd6101c.jpg";